import React from "react";

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
// core components
import Header from "components/Header/HeaderLogin.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Button from "components/CustomButtons/Button.jsx";
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CustomInput from "components/CustomInput/CustomInput.jsx";
import loginPageStyle from "assets/jss/material-kit-pro-react/views/loginPageStyle.jsx";
import image from "assets/img/FondoBlanco.jpg";
import Globales from "utils/Globales";
import Snackbar from "components/Snackbar/Snackbar.jsx";
import CookiesU from 'universal-cookie';

import ModalCargando from "../../components/Generales/ModalCargando";

const cookies = new CookiesU();
class VerificarToken extends React.Component {

  constructor(props, context) {
    super(props, context);
    this.state = {
      Token: '',
      errorToken: '',
      errorContrasena: '',
      colorNotificacion: 'success',
      mensaje: '',
      br: false,
      cargando:false,
      NombreUsuario: '',
      NombreCompleto: ''
    }
    global.nombreUsuario = '';
    this.IniciarSesion = this.IniciarSesion.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.enterFunction = this.enterFunction.bind(this);
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    document.body.scrollTop = 0;
    document.addEventListener("keypress", this.enterFunction, false);
    
    cookies.remove("NumeroIdReglamento")
    cookies.remove("NumeroIdAlumno")
    cookies.remove("NumeroIdioma")
    
    cookies.remove("idAlumnoFirma")
    cookies.remove("idReglamento")
    cookies.remove("idIdioma")

    // let Galletas = cookies.getAll();
    // console.log(cookies.getAll())
    // localStorage.removeItem('Permisos');
  }

  enterFunction(event) {
    if (event.keyCode === 13) {
      this.IniciarSesion();
    }
  }

  handleChange(e) {
    const { name, value } = e.target;
    this.setState({
      [name]: value
    });
  }

  IniciarSesion() {
    this.setState({cargando:true})
    //Validar que los campos no esten vacios
    if (this.state.Usuario !== '' && this.state.Contrasena !== '') {
      fetch(Globales.Url + 'Firmas/Firmas/validarTokenReglamento', {
        method: 'POST', headers: {
          'Accept': 'application/json', 'Content-Type': 'application/json'
        }, body: JSON.stringify({
          token:this.state.Token
        })
      })
        .then(res => res.json()).then(data => {
          // console.log(data);
          if (!data.error) {
            // IDs 
            cookies.set('idAlumnoFirma', data.data._idAlumno, { path: '/' });
            cookies.set('idReglamento', data.data._idReglamento, { path: '/' });
            cookies.set('idIdioma', data.data._idIdioma, { path: '/' });
            // IDs EN STRING
            cookies.set('NumeroIdReglamento', data.data.NumeroIdReglamento, { path: '/' });
            cookies.set('NumeroIdAlumno', data.data.NumeroIdAlumno, { path: '/' });
            cookies.set('NumeroIdioma', data.data.NumeroIdioma, { path: '/' });

            this.setState({ cargando: false, colorNotificacion: 'success', mensaje: 'Token correcto' });
            this.showNotification();
            window.location.href = '#/FirmaReglamento/Firmar';
            window.location.reload()
          } else {
            this.setState({ cargando: false, colorNotificacion: 'danger', mensaje: 'Token incorrecto' });
            this.showNotification();
          }
        });
    } else {
      this.setState({cargando:false, errorUsuario: true, errorContrasena: true, colorNotificacion: 'danger', mensaje: 'Complete los campos para iniciar sesión' });
      this.showNotification();
    }
  }

  showNotification() {
    var x = [];
    this.setState({ br: true });
    this.setState(x);
    this.alertTimeout = setTimeout(
      function () {
        this.setState({ br: false });
        this.setState(x);
      }.bind(this),
      4000
    );
  }

  render() {
    const { classes } = this.props;
    var agregar 
    if (this.state.cargando == true) {
      agregar = (
        <ModalCargando
          Cuerpo={"Cargando"}
          show={this.state.cargando}
        />
      );
    }

    return (
      <div>
        <Header
          absolute
          color="transparent"
        />
        <div
          className={classes.pageHeader}
          style={{
            backgroundImage: "url(" + image + ")",
             backgroundSize: "100% 100%",
             backgroundPosition: "center",
             backgroundRepeat:"no-repeat"
          }}
        >
          <div className={classes.container}>
            <GridContainer justify="center">
              <GridItem xs={12} sm={12} md={4}>
                <Card>
                  <form className={classes.form}>
                    <CardHeader
                      color="info"
                      signup
                      className={classes.cardHeader}
                    >
                      <h4>Firmar reglamento</h4>
                    </CardHeader>
                    <CardBody signup>
                      <CustomInput
                        labelText="Token"
                        id="first"
                        formControlProps={{
                          fullWidth: true
                        }}
                        inputProps={{
                          required: true,
                          onChange: this.handleChange.bind(this),
                          value: this.state.Token,
                          name: "Token",
                          id: "Token",
                          type: "number",
                          error: this.state.errorToken,
                          autoComplete: "off"
                        }}
                      />
                    </CardBody>
                  </form>
                  <div className={classes.textCenter}>
                    <Button type="submit" round color="default" onClick={this.IniciarSesion.bind(this)}>Validar</Button>
                  </div>
                </Card>
              </GridItem>
            </GridContainer>
          </div>
        </div>
        <div id="">
          <Snackbar
            place="tr"
            color={this.state.colorNotificacion}
            message={this.state.mensaje}
            open={this.state.br}
            closeNotification={() => this.setState({ br: false })}
            close
          />
        </div>
        {agregar}
      </div>
    );
  }
}

export default withStyles(loginPageStyle)(VerificarToken);
